import Cookies from 'js-cookie'

export function getToken() {
  return Cookies.get('userid')
}

export function setToken(token) {
  return Cookies.set('userid', token)
}

export function removeToken() {
  return Cookies.remove('userid')
}



// WEBPACK FOOTER //
// ./src/utils/auth.js